"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
export let ManifestLoader = /*#__PURE__*/function () {
  function ManifestLoader(publicPath, cacheManager) {
    _defineProperty(this, "manifests", new Map());
    _defineProperty(this, "manifestLoadPromise", null);
    _defineProperty(this, "masterManifestMetadata", null);
    _defineProperty(this, "hasNoTranslations", false);
    this.publicPath = publicPath;
    this.cacheManager = cacheManager;
  }

  /**
   * Load the master manifest metadata
   */
  var _proto = ManifestLoader.prototype;
  _proto.loadMasterManifest = async function loadMasterManifest() {
    if (this.manifestLoadPromise) return this.manifestLoadPromise;

    // Skip in development mode
    if (typeof (process.env.NODE_ENV !== "production") !== 'undefined' && process.env.NODE_ENV !== "production") {
      return Promise.resolve();
    }
    this.manifestLoadPromise = (async () => {
      try {
        // Remove trailing slash for consistent path construction
        const basePath = this.publicPath.endsWith('/') ? this.publicPath.slice(0, -1) : this.publicPath;

        // The manifest is at the root level, not inside /locales/
        const metadataUrl = basePath ? `${basePath}/i18n-master-manifest.json` : '/i18n-master-manifest.json';
        const response = await fetch(metadataUrl, {
          cache: 'no-cache'
        });
        if (!response.ok) {
          // Check if this is a 403/404 which likely means no translations exist
          if (response.status === 403 || response.status === 404) {
            if (__DEBUG__) {
              console.log('[i18n] No translation manifest found - this MFE has no translations');
            }
            this.hasNoTranslations = true;
            return;
          }
          throw new Error(`Failed to load manifest metadata: HTTP ${response.status} from ${metadataUrl}`);
        }
        this.masterManifestMetadata = await response.json();

        // Check if manifest indicates empty translations
        if (this.masterManifestMetadata && this.masterManifestMetadata.empty === true) {
          if (__DEBUG__) {
            console.log('[i18n] Empty translation manifest detected');
          }
          this.hasNoTranslations = true;
        }
      } catch (error) {
        if (__DEBUG__) {
          console.error('[i18n] Failed to load master manifest:', error);
        }
        // Mark as having no translations to prevent repeated attempts
        this.hasNoTranslations = true;
      }
    })();
    return this.manifestLoadPromise;
  }

  /**
   * Check if this app has translations
   */;
  _proto.hasTranslations = function hasTranslations() {
    return !this.hasNoTranslations;
  }

  /**
   * Load a specific locale's manifest
   */;
  _proto.loadLocaleManifest = async function loadLocaleManifest(locale) {
    // If we know there are no translations, return early
    if (this.hasNoTranslations) {
      return null;
    }

    // Check if already loaded in memory
    if (this.manifests.has(locale)) {
      return this.manifests.get(locale);
    }
    try {
      // Ensure master manifest is loaded
      if (!this.masterManifestMetadata) {
        await this.loadMasterManifest();
      }
      if (!this.masterManifestMetadata) {
        throw new Error('Master manifest metadata not available');
      }
      const moduleInfo = this.masterManifestMetadata.manifestModules[locale];
      if (!moduleInfo) {
        if (__DEBUG__) {
          console.warn(`Locale "${locale}" not found in manifest modules`);
        }
        return null;
      }

      // Load the manifest module
      const manifest = await this.loadManifestModule(locale, moduleInfo.name);
      if (manifest) {
        this.manifests.set(locale, manifest);
        // Cache for offline capability
        await this.cacheManager.setManifest(locale, manifest);
        return manifest;
      }
    } catch (error) {
      if (__DEBUG__) {
        console.error(`[i18n] Failed to load manifest for locale ${locale}:`, error);
      }

      // Try to load from cache
      const cachedManifest = await this.cacheManager.getManifest(locale);
      if (cachedManifest) {
        this.manifests.set(locale, cachedManifest);
        return cachedManifest;
      }
    }
    return null;
  }

  /**
   * Load and parse a manifest module using secure dynamic import
   *
   * Security Note:
   * The manifest files are ES modules (export const manifest={...}) generated at build time.
   * We use dynamic import() instead of new Function() or JSON.parse() because:
   *
   * 1. SAFER THAN new Function():
   *    - new Function() executes arbitrary code (XSS/code injection risk)
   *    - import() goes through browser's secure module system with:
   *      • Content Security Policy enforcement
   *      • Same-origin policy validation
   *      • Module integrity checks
   *      • Strict mode execution
   *
   * 2. WORKS WITH ES MODULES (unlike JSON.parse):
   *    - Manifests use ES module syntax: export const manifest={...}
   *    - JSON.parse() would fail on 'export' keyword
   *    - import() is the standard way to load ES modules
   *
   * 3. ADDITIONAL SECURITY:
   *    - Cannot execute code outside module boundaries
   *    - Browser validates module origin and integrity
   *    - CSP 'script-src' policies apply (no 'unsafe-eval' needed)
   *    - Prevents compromised CDN from executing arbitrary code
   *
   * This addresses the critical security vulnerability while maintaining
   * compatibility with the build system's ES module output format.
   */;
  _proto.loadManifestModule = async function loadManifestModule(locale, moduleName) {
    const basePath = this.publicPath.endsWith('/') ? this.publicPath.slice(0, -1) : this.publicPath;

    // The manifest modules are at the root level, not inside /locales/
    const manifestUrl = basePath ? `${basePath}/${moduleName}` : `/${moduleName}`;
    try {
      // Dynamic import provides secure module loading through browser's native module system
      // webpackIgnore comment prevents webpack from bundling the module at compile time
      const module = await import(/* webpackIgnore: true */manifestUrl);
      if (!module.manifest) {
        throw new Error(`Manifest module for ${locale} does not export 'manifest'`);
      }
      return module.manifest;
    } catch (error) {
      if (__DEBUG__) {
        console.error(`Failed to load manifest module for ${locale}:`, error);
      }
      throw new Error(`Failed to load manifest for ${locale}: ${error instanceof Error ? error.message : String(error)}`);
    }
  }

  /**
   * Get the supported locales
   */;
  _proto.getSupportedLocales = function getSupportedLocales() {
    var _this$masterManifestM;
    return ((_this$masterManifestM = this.masterManifestMetadata) === null || _this$masterManifestM === void 0 ? void 0 : _this$masterManifestM.locales) || ['en'];
  }

  /**
   * Check if manifest system is available
   */;
  _proto.isAvailable = function isAvailable() {
    return this.masterManifestMetadata !== null;
  }

  /**
   * Get translation info for a specific namespace
   */;
  _proto.getTranslationInfo = function getTranslationInfo(locale, namespace) {
    const manifest = this.manifests.get(locale);
    return (manifest === null || manifest === void 0 ? void 0 : manifest[namespace]) || null;
  };
  return ManifestLoader;
}();